// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1trhI","right":"styles_right__1UDA_"};